const isPHEV = vehicle => {
  const fuelType = vehicle && vehicle.fuel ? vehicle.fuel : "";
  return ["PHEV"].includes(fuelType.toUpperCase());
};

export default isPHEV;
